<template>
  <Frequency v-if="frequencyDialog" :dialog="frequencyDialog" @confirm="setFrequency" @close="closeFrequencyDialog" :onboarding="onboarding" :tourStatus="isTourActive" />
  <Whitelist v-if="whitelistDialog" :dialog="whitelistDialog" @confirm="setWhitelist" @close="closeWhitelistDialog" :onboarding="onboarding" :tourStatus="isTourActive" />
  <VOnboardingWrapper ref="wrapper" :steps="steps" :options="onboardingOptions" @finish="onTourFinish" @exit="onTourExit" />

  <div>
    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Settings</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Phishing</li>
        </ol>
      </nav>

			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body">
                <!-- phishing buttons first row -->
                <div class="row">
                  <div class="col-md-8 col-xs-12">
                    <div class="d-flex flex-row align-items-center">
                      <div class="align-middle p-2 col-5" style="font-size: 14px; position: relative;">
                        <div class="input-group">
                          <input type="text" class="form-control" placeholder="Search template..." aria-label="Username" v-model="search" aria-describedby="search" style="box-sizing: border-box; width: 331px; height: 40px; border: 1px solid #D9D9D9; border-radius: 20px; padding-left: 40px;">
                          <span class="input-group-addon" style="position: absolute; left: 20px; top: 50%; transform: translateY(-50%); background-color: white;">
                            <i class="fas fa-search"></i>
                          </span>
                        </div>
                      </div>
                      <div class="align-middle p-2 col-lg-7 col-md-7 col-xs-12">
                        <button type="button" class="btn btn-outline-primary btn-create" @click="frequencyDialog = true;" v-tooltip.top="'Set Frequency'">Set Frequency</button>
                        <!-- <button type="button" class="ms-3 btn btn-outline-primary btn-create" @click="setAudience" v-tooltip.top="'Set Audience'">
                          <div v-if="audienceLoading" class="spinner-border" role="status" style="height:15px; width:15px;">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          Select Audience
                        </button> -->
                        <button type="button" class="ms-3 btn btn-outline-primary-inverse btn-create" @click="whitelistDialog = true;" v-tooltip.top="'Set Allow List'">Confirm Allow List</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-xs-12">
                    <div class="d-flex flex-row-reverse">
                      <!-- <div class="align-middle p-2 col-xs-12">
                        <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                          <button type="button" class="btn btn-square btn-labeled" :class="view.list ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.list" @click="view.list = !view.list, view.grid = !view.list" v-tooltip.top="'Switch to List View'"><span class="btn-label"><i class="fas fa-list"></i></span></button>
                          <button type="button" class="btn btn-square btn-labeled" :class="view.grid ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.grid" @click="view.grid = !view.grid, view.list = !view.grid" v-tooltip.top="'Switch to Tile View'"><span class="btn-label"><i class="fas fa-border-all"></i></span></button>
                        </div>
                      </div> -->
                      <div class="col-xs-12 p-3" style="font-size:14px;">
                        <div class="dropdown-toggle text-default" id="sortBy" data-bs-toggle="dropdown" aria-expanded="false">
                          <span> <strong>Sort by: </strong></span>
                          <span class="text-info" style="cursor:pointer;">{{sortBy ? sortBy.label : "Created Date"}} </span>
                          <ul class="dropdown-menu w-25" aria-labelledby="sortBy">
                            <li><span class="dropdown-item" v-for="(item,index) in sortByOptions" :key="index" @click="sortBy = item"> {{item.label}} </span></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- phishing buttons 2nd row -->
                <div class="row mb-3 mt-2" v-if="!loading">
                  <div class="col-md-12 col-xs-12">
                    <div class="d-flex align-items-center justify-content">
                      <div id="setup-phishing-tests"  class="align-middle p-2 ps-4" style="font-size: 14px; position: relative;">
                        <!-- Your SVG and label content here -->
                        <span>
                          <svg width="21" height="27" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19.4202 10.2101C19.4202 8.49966 18.315 7.05236 16.7888 6.49975V2.31573C16.7888 1.59208 16.1967 1 15.473 1C14.7494 1 14.1573 1.59208 14.1573 2.31573V6.49975C12.6311 7.05236 11.5258 8.49966 11.5258 10.2101C11.5258 11.9206 12.6311 13.3679 14.1573 13.9205V17.8808C14.1573 20.6307 12.1574 23.0911 9.42068 23.3542C6.28924 23.6437 3.63147 21.1833 3.63147 18.1045V16.7888H5.98663C6.5787 16.7888 6.86817 16.0783 6.44713 15.6704L2.11838 11.3285C2.02563 11.2376 1.90804 11.1761 1.78043 11.1519C1.65282 11.1277 1.5209 11.1418 1.4013 11.1925C1.2817 11.2432 1.17977 11.3281 1.10836 11.4366C1.03695 11.5451 0.999248 11.6723 1.00001 11.8021V17.8282C1.00001 21.8412 3.88146 25.4199 7.85496 25.9331C12.6705 26.5515 16.7888 22.8016 16.7888 18.1045V13.9205C18.315 13.3679 19.4202 11.9206 19.4202 10.2101ZM15.473 11.5258C14.7494 11.5258 14.1573 10.9338 14.1573 10.2101C14.1573 9.48646 14.7494 8.89438 15.473 8.89438C16.1967 8.89438 16.7888 9.48646 16.7888 10.2101C16.7888 10.9338 16.1967 11.5258 15.473 11.5258Z" stroke="#00A0C1" stroke-width="1.25"/>
                            </svg>
                        </span>
                        <span class="ps-2" style="color:#555555; font-weight: 400; font-size: 14px;">
                          Auto Phishing
                        </span>
                      </div>
                      <div id="auto-phishing-toggle" style="min-width: 10px; min-height: 10px;">
                        <label class="form-check form-switch custom-slider custom-icon-btn ms-2" v-tooltip.top="'Turn on Phishing'">
                          <input class="form-check-input" type="checkbox" role="switch" v-model="phishingStatus"  @change="() => setPhishing(false)">
                          <span class="slider">
                            <span class="slider-button"></span>
                          </span>
                        </label>
                      </div>
                      <div class="align-middle p-2 ms-2">
                        <span style="font-size: 14px;">Status: <span :style="{ color: status ? 'green' : 'red' }">{{ status ? 'Live' : 'Not Live' }}</span></span>
                      </div>
                      <div class="align-middle p-2" style="font-size: 14px;" v-if="view.grid">
                        <span class="ms-2">
                          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.15146 2.6748V4.64266C5.18692 5.64519 3.61701 7.27978 2.69457 9.28317C1.77213 11.2866 1.55086 13.5421 2.0664 15.6866C2.58195 17.831 3.80429 19.7395 5.53656 21.1047C7.26883 22.4699 9.41019 23.2123 11.6157 23.2123C13.8213 23.2123 15.9627 22.4699 17.6949 21.1047C19.4272 19.7395 20.6495 17.831 21.1651 15.6866C21.6806 13.5421 21.4594 11.2866 20.5369 9.28317C19.6145 7.27978 18.0446 5.64519 16.08 4.64266V2.6748C18.5555 3.70839 20.5967 5.56728 21.8567 7.93553C23.1167 10.3038 23.5178 13.0353 22.9918 15.6658C22.4658 18.2963 21.0451 20.6635 18.9713 22.3651C16.8974 24.0667 14.2983 24.9977 11.6157 24.9998C8.93092 25.0018 6.32844 24.073 4.25154 22.3716C2.17465 20.6702 0.751807 18.3014 0.225351 15.6687C-0.301105 13.036 0.101386 10.3022 1.36427 7.9329C2.62716 5.56364 4.67234 3.70544 7.15146 2.6748Z" fill="#00A0C1"/>
                          <path d="M11.6158 0C12.211 0 12.5086 0.297619 12.5086 0.892857V9.82143C12.5086 10.4167 12.211 10.7143 11.6158 10.7143C11.0205 10.7143 10.7229 10.4167 10.7229 9.82143V0.892857C10.7229 0.297619 11.0205 0 11.6158 0Z" fill="#00A0C1"/>
                          </svg>
                        </span>
                        <span  class="ps-2 text-default">Active Templates: </span>
                      </div>
                      <label class="form-check form-switch custom-slider custom-icon-btn " v-tooltip.top="'Show/Hide active templates'"  v-if="view.grid">
                        <input class="form-check-input" type="checkbox" role="switch" v-model="activeTemplates">
                        <span class="slider">
                          <span class="slider-button"></span>
                        </span>
                      </label>
                      <div class="align-middle p-2" style="font-size: 14px;">
                        <span class="ms-2">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.75 12.7188L16.5625 15.5312C16.7917 15.7604 16.9062 16.0471 16.9062 16.3913C16.9062 16.7346 16.7917 17.0312 16.5625 17.2812C16.3125 17.5312 16.0158 17.6562 15.6725 17.6562C15.3283 17.6562 15.0312 17.5312 14.7812 17.2812L12.125 14.625C11.8333 14.3333 11.6146 14.0104 11.4688 13.6562C11.3229 13.3021 11.25 12.9167 11.25 12.5V8.75C11.25 8.39583 11.37 8.09875 11.61 7.85875C11.8492 7.61958 12.1458 7.5 12.5 7.5C12.8542 7.5 13.1513 7.61958 13.3913 7.85875C13.6304 8.09875 13.75 8.39583 13.75 8.75V12.7188ZM12.5 2.5C12.8542 2.5 13.1513 2.61958 13.3913 2.85875C13.6304 3.09875 13.75 3.39583 13.75 3.75C13.75 4.10417 13.6304 4.40125 13.3913 4.64125C13.1513 4.88042 12.8542 5 12.5 5C12.1458 5 11.8492 4.88042 11.61 4.64125C11.37 4.40125 11.25 4.10417 11.25 3.75C11.25 3.39583 11.37 3.09875 11.61 2.85875C11.8492 2.61958 12.1458 2.5 12.5 2.5ZM22.5 12.5C22.5 12.8542 22.38 13.1508 22.14 13.39C21.9008 13.63 21.6042 13.75 21.25 13.75C20.8958 13.75 20.5992 13.63 20.36 13.39C20.12 13.1508 20 12.8542 20 12.5C20 12.1458 20.12 11.8487 20.36 11.6087C20.5992 11.3696 20.8958 11.25 21.25 11.25C21.6042 11.25 21.9008 11.3696 22.14 11.6087C22.38 11.8487 22.5 12.1458 22.5 12.5ZM12.5 20C12.8542 20 13.1513 20.12 13.3913 20.36C13.6304 20.5992 13.75 20.8958 13.75 21.25C13.75 21.6042 13.6304 21.9008 13.3913 22.14C13.1513 22.38 12.8542 22.5 12.5 22.5C12.1458 22.5 11.8492 22.38 11.61 22.14C11.37 21.9008 11.25 21.6042 11.25 21.25C11.25 20.8958 11.37 20.5992 11.61 20.36C11.8492 20.12 12.1458 20 12.5 20ZM5 12.5C5 12.8542 4.88042 13.1508 4.64125 13.39C4.40125 13.63 4.10417 13.75 3.75 13.75C3.39583 13.75 3.09875 13.63 2.85875 13.39C2.61958 13.1508 2.5 12.8542 2.5 12.5C2.5 12.1458 2.61958 11.8487 2.85875 11.6087C3.09875 11.3696 3.39583 11.25 3.75 11.25C4.10417 11.25 4.40125 11.3696 4.64125 11.6087C4.88042 11.8487 5 12.1458 5 12.5ZM12.5 25C10.7708 25 9.14583 24.6717 7.625 24.015C6.10417 23.3592 4.78125 22.4688 3.65625 21.3438C2.53125 20.2188 1.64083 18.8958 0.985 17.375C0.328333 15.8542 0 14.2292 0 12.5C0 10.7708 0.328333 9.14583 0.985 7.625C1.64083 6.10417 2.53125 4.78125 3.65625 3.65625C4.78125 2.53125 6.10417 1.64042 7.625 0.98375C9.14583 0.327917 10.7708 0 12.5 0C14.2292 0 15.8542 0.327917 17.375 0.98375C18.8958 1.64042 20.2188 2.53125 21.3438 3.65625C22.4688 4.78125 23.3592 6.10417 24.015 7.625C24.6717 9.14583 25 10.7708 25 12.5C25 14.2292 24.6717 15.8542 24.015 17.375C23.3592 18.8958 22.4688 20.2188 21.3438 21.3438C20.2188 22.4688 18.8958 23.3592 17.375 24.015C15.8542 24.6717 14.2292 25 12.5 25ZM12.5 22.5C15.2917 22.5 17.6562 21.5312 19.5938 19.5938C21.5312 17.6562 22.5 15.2917 22.5 12.5C22.5 9.70833 21.5312 7.34375 19.5938 5.40625C17.6562 3.46875 15.2917 2.5 12.5 2.5C9.70833 2.5 7.34375 3.46875 5.40625 5.40625C3.46875 7.34375 2.5 9.70833 2.5 12.5C2.5 15.2917 3.46875 17.6562 5.40625 19.5938C7.34375 21.5312 9.70833 22.5 12.5 22.5Z" fill="#00A0C1"/>
                            </svg>
                        </span>
                        <span class="ps-2 text-default">
                          Frequency:
                          <span v-if="!loading && campaigns.length && campaigns[0].frequency" style="font-weight: 900;">
                            {{ campaigns[0].frequency }} Days
                          </span>
                        </span>
                      </div>
                      <div class="align-middle p-2" style="font-size: 14px;">
                        <span class="ms-3">
                          <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.2513 0.00178418C15.3052 0.00178418 16.3159 0.420437 17.0611 1.16564C17.8063 1.91085 18.225 2.92157 18.225 3.97545C18.225 5.02933 17.8063 6.04005 17.0611 6.78525C16.3159 7.53046 15.3052 7.94911 14.2513 7.94911C13.1972 7.94911 12.1862 7.53036 11.4409 6.78499C10.6955 6.03962 10.2767 5.02867 10.2767 3.97456C10.2767 2.92044 10.6955 1.90949 11.4409 1.16412C12.1862 0.418747 13.1972 0.00178418 14.2513 0.00178418ZM14.2513 1.7861C13.6707 1.7861 13.1138 2.01676 12.7032 2.42734C12.2926 2.83793 12.062 3.3948 12.062 3.97545C12.062 4.5561 12.2926 5.11297 12.7032 5.52355C13.1138 5.93414 13.6707 6.1648 14.2513 6.1648C14.8322 6.1648 15.3893 5.93404 15.8 5.52329C16.2108 5.11254 16.4415 4.55544 16.4415 3.97456C16.4415 3.39367 16.2108 2.83657 15.8 2.42582C15.3893 2.01507 14.8322 1.7861 14.2513 1.7861ZM1.81286 15.1863C1.81286 15.4229 1.71887 15.6498 1.55155 15.8171C1.38424 15.9844 1.15732 16.0784 0.920705 16.0784C0.684091 16.0784 0.457167 15.9844 0.289855 15.8171C0.122544 15.6498 0.0285491 15.4229 0.0285491 15.1863V10.7505C0.0286067 10.3134 0.189059 9.89162 0.479472 9.56503C0.769885 9.23844 1.17006 9.02979 1.6041 8.97866L1.81286 8.96617H6.73221C6.47259 9.41415 6.31424 9.91357 6.26829 10.4293L6.25401 10.7505H1.81108L1.81286 15.1863ZM27.639 16.0784C27.8756 16.0784 28.1025 15.9844 28.2698 15.8171C28.4372 15.6498 28.5312 15.4229 28.5312 15.1863V10.7505L28.5187 10.5435C28.4679 10.1091 28.2595 9.70854 27.9328 9.41776C27.6062 9.12698 27.1842 8.96628 26.7468 8.96617H21.7793C22.0398 9.4176 22.2076 9.93505 22.2468 10.4846L22.2557 10.7523H26.7468V15.1863C26.7468 15.4229 26.8408 15.6498 27.0081 15.8171C27.1755 15.9844 27.4024 16.0784 27.639 16.0784ZM18.6889 8.96617C19.1262 8.96628 19.5482 9.12698 19.8749 9.41776C20.2015 9.70854 20.41 10.1091 20.4607 10.5435L20.4714 10.7505V15.1863C20.4714 15.4229 20.3774 15.6498 20.2101 15.8171C20.0428 15.9844 19.8159 16.0784 19.5793 16.0784C19.3426 16.0784 19.1157 15.9844 18.9484 15.8171C18.7811 15.6498 18.6871 15.4229 18.6871 15.1863V10.7505H9.82264V15.1863C9.82264 15.4229 9.72865 15.6498 9.56133 15.8171C9.39402 15.9844 9.1671 16.0784 8.93048 16.0784C8.69387 16.0784 8.46695 15.9844 8.29963 15.8171C8.13232 15.6498 8.03833 15.4229 8.03833 15.1863V10.7505C8.03839 10.3134 8.19884 9.89162 8.48925 9.56503C8.77966 9.23844 9.17984 9.02979 9.61388 8.97866L9.82264 8.96617H18.6871H18.6889ZM26.5648 4.53572C26.5648 3.6302 26.2051 2.76176 25.5648 2.12146C24.9245 1.48116 24.0561 1.12144 23.1506 1.12144C22.245 1.12144 21.3766 1.48116 20.7363 2.12146C20.096 2.76176 19.7363 3.6302 19.7363 4.53572C19.7363 5.44125 20.096 6.30968 20.7363 6.94998C21.3766 7.59029 22.245 7.95 23.1506 7.95C24.0561 7.95 24.9245 7.59029 25.5648 6.94998C26.2051 6.30968 26.5648 5.44125 26.5648 4.53572ZM21.5206 4.53572C21.5206 4.10343 21.6923 3.68884 21.998 3.38316C22.3037 3.07748 22.7183 2.90575 23.1506 2.90575C23.5829 2.90575 23.9974 3.07748 24.3031 3.38316C24.6088 3.68884 24.7805 4.10343 24.7805 4.53572C24.7805 4.96802 24.6088 5.38261 24.3031 5.68828C23.9974 5.99396 23.5829 6.16569 23.1506 6.16569C22.7183 6.16569 22.3037 5.99396 21.998 5.68828C21.6923 5.38261 21.5206 4.96802 21.5206 4.53572ZM5.38149 1.12055C6.28701 1.12055 7.15545 1.48027 7.79575 2.12057C8.43605 2.76087 8.79577 3.62931 8.79577 4.53483C8.79577 5.44035 8.43605 6.30879 7.79575 6.94909C7.15545 7.58939 6.28701 7.94911 5.38149 7.94911C4.47596 7.94911 3.60753 7.58939 2.96722 6.94909C2.32692 6.30879 1.9672 5.44035 1.9672 4.53483C1.9672 3.62931 2.32692 2.76087 2.96722 2.12057C3.60753 1.48027 4.47596 1.12055 5.38149 1.12055ZM5.38149 2.90486C4.94919 2.90486 4.5346 3.07659 4.22892 3.38227C3.92325 3.68795 3.75152 4.10253 3.75152 4.53483C3.75152 4.96712 3.92325 5.38171 4.22892 5.68739C4.5346 5.99307 4.94919 6.1648 5.38149 6.1648C5.81378 6.1648 6.22837 5.99307 6.53405 5.68739C6.83973 5.38171 7.01146 4.96712 7.01146 4.53483C7.01146 4.10253 6.83973 3.68795 6.53405 3.38227C6.22837 3.07659 5.81378 2.90486 5.38149 2.90486ZM0.892156 17.8628C0.655542 17.8628 0.428618 17.9567 0.261307 18.1241C0.0939949 18.2914 0 18.5183 0 18.7549V20.5392C0 21.7223 0.469974 22.8569 1.30653 23.6935C2.14309 24.53 3.27771 25 4.46078 25H24.0882C25.2713 25 26.4059 24.53 27.2425 23.6935C28.079 22.8569 28.549 21.7223 28.549 20.5392V18.7549C28.549 18.5183 28.455 18.2914 28.2877 18.1241C28.1204 17.9567 27.8935 17.8628 27.6568 17.8628H0.892156ZM1.78431 20.5392V19.6471H26.7647V20.5392C26.7647 21.2491 26.4827 21.9298 25.9808 22.4318C25.4788 22.9337 24.7981 23.2157 24.0882 23.2157H4.46078C3.75094 23.2157 3.07017 22.9337 2.56823 22.4318C2.0663 21.9298 1.78431 21.2491 1.78431 20.5392Z" fill="#00A0C1"/>
                          </svg>
                        </span>
                        <span v-if="!loading"  class="ps-2 text-default">Audience: <span  style="font-weight: 900;">{{ audience }}</span></span>
                      </div>
                      <label id="report-notifications-toggle" class="form-check form-switch custom-slider custom-icon-btn ms-3" v-tooltip.top="'Enable/Disable Phishing Reports'">
                        <input class="form-check-input" type="checkbox" role="switch" v-model="phishingReport" @click="changePhishingReportStatus">
                        <span class="slider">
                          <span class="slider-button"></span>
                        </span>
                      </label>
                      <div class="align-middle p-2" style="font-size: 14px; cursor:pointer;"  @click="phishingReportDialog = true" v-tooltip.top="'Add email recipients'">
                        <span>
                          <i style="font-size: 20px;color:#00A0C1;" class="fas fa-file-alt"></i>
                        </span>
                        <span  class="ps-2 text-default">Report Notification</span>
                      </div>

                    </div>
                  </div>
                </div>

                <div>
                  <div class="mt-2">
                    <div class="row">

                      <div v-if="loading" class="text-center align-middle">
                        <img src="@/assets/img/loading.svg">
                      </div>

                      <div v-else>
                        <!-- grid view -->
                        <div class="row"  v-if="!loading && view.grid">
                          <div v-for="(item, index) in templates" :key="index">
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-2 card-body text-default" v-if="activeTemplates == item.is_active">
                              <div style="position: relative; width: 100%; height: 0; padding-bottom: 56.25%;">
                                <img v-lazy="item.template.thumbnail" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; box-shadow: 0 0 5px gray;" alt="Template Thumbnail">
                              </div>
                              <div class="pa-0 mt-2">
                                <h6 style="font-size:14px;"><strong>{{ item.template.name}}</strong></h6>
                                <span><small class="text-muted">Vertex or Client Input: </small><strong style="font-size:14px;">{{ item.template.template_mapping.input_type ? "Vertex" : "Client"}}</strong></span>
                                <br />
                                <span><small class="text-muted">Client Name: </small> <strong style="font-size:14px;">{{  item.organisation_id == 0 ? "N/A" : "Client" }}</strong></span>
                                <br>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="!loading && !tableLoading && view.list">
                          <!-- list view -->
                          <table class="table">
                            <thead>
                              <tr class="table-light text-default">
                                <th>Phishing Email</th>
                                <th>Vertex or Client Input</th>
                                <th>Link to Domain</th>
                                <th>Activate Template</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle text-default" v-for="(item, index) in templates" :key="index">
                              <tr>
                                  <td> {{ item.template.name }}</td>
                                  <td>{{ item.template.template_mapping.input_type ? "Vertex" : "Client"}} </td>
                                  <td>
                                    {{  item.template.domain}}
                                  </td>
                                  <td>
                                    <label class="form-check form-switch custom-slider custom-icon-btn " v-tooltip.top="'Enable/Disable Template'" id="activate-template-toggle">
                                      <!-- <input class="form-check-input" type="checkbox" role="switch" v-model="item.is_active" @click="setTemplate(item.id, item.is_active)"> -->
                                      <input class="form-check-input" type="checkbox" role="switch" v-model="item.is_active" @click="setTemplate(item.ID, item.is_active)">
                                      <span class="slider">
                                        <span class="slider-button"></span>
                                      </span>
                                    </label>
                                  </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


							</div>
						</div>
					</div>
				</div>
			</div>

    </div>
  </div>

    <!-- report dialog -->
    <div>
    <vue-final-modal v-model="phishingReportDialog" @before-close="recipientsCheck" classes="modal-container" content-class="modal-content" :click-to-close="!isTourActive">

    <div class="modal-header justify-content-between">
      <span class="modal__title text-white">Recipients</span>
      <div>
        <button type="button" class="btn-close" aria-label="Close" @click="closeReportDialog()"></button>
      </div>
    </div>

    <div class="modal__body">
      <div class="modal__content mt-3">
        <div :class="{ error: v$.editedPhishingReport.email.$errors.length }">
          <div class="col mb-5">
            <label class="form-label">Email address</label>
            <div class="input-group">
              <input type="email" class="form-control" v-model="editedPhishingReport.email" id="floatingInput" placeholder="name@example.com" @blur="v$.editedPhishingReport.email.$touch()">
              <button type="button" class="btn btn-outline-primary" @click="saveRecipient()">{{editedIndex == -1 ? 'Add' : 'Update'}}</button>
            </div>
            <div class="text-danger" v-for="error of v$.editedPhishingReport.email.$errors" :key="error.$uid">
              <div class="form-text text-danger">{{ error.$message }}</div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <table id="manage-recipients" class="table mb-5 mt-2">
          <thead>
            <tr class="table-light text-default">
              <th>Email</th>
              <th style="text-align: right;">Actions</th>
            </tr>
          </thead>
            <tbody v-for="(item, index) in phishingReports" :key="index">
              <tr>
                <td>{{ item.email }}</td>
                <td style="text-align:right;">
                  <button type="button" class="btn btn-default btn-circle ms-1" @click="editPhishingReport(item)"><i class="fas fa-edit"></i></button>
                  <button type="button" class="btn btn-default btn-circle-danger ms-1" @click="deleteRecipient(item)"><i class="fas fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
        </table>
        </div>
      </div>
    </div>
    </vue-final-modal>
  </div>
  <!-- report dialog -->
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted, getCurrentInstance, nextTick } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import moment from 'moment'
import { debounce } from '@/plugins/helper.js'
import Frequency from '@/components/phishing/Frequency.vue'
import Whitelist from '@/components/phishing/Whitelist.vue'
import { VOnboardingWrapper, useVOnboarding } from 'v-onboarding'
import 'v-onboarding/dist/style.css'


const { proxy } = getCurrentInstance();

const toast = proxy.$toast;
const axios = proxy.$axios;
const helper = proxy.$helper;
const store =  proxy.$store;

// Refs & reactive state
const loading = ref(false)
const status = ref(false)
const phishingStatus = ref(false)
const phishingReport = ref(false)
const frequencyDialog = ref(false)
const whitelistDialog = ref(false)
const phishingReportDialog = ref(false)
const addRecipientRequired = ref(false)
const editedIndex = ref(-1)
const phishingReportID = ref(0)
const settingWhiteList = ref(false)

const frequencySet = ref(false)
const whiteListSet = ref(false)


const orgID = ref(null)
orgID.value = helper.setOrganisationID()
const search = ref("")
const sortBy = ref(null)
const tableLoading = ref(false)
const campaigns = ref([])
const templates = ref([])
const phishingReports = ref([])

const editedPhishingReport = reactive({
  email: ''
})

const view = reactive({
  list: true,
  grid: false,
})

const sortByOptions = [
  { label: "Name", value: "name" },
  { label: "Created Date", value: "created_at" },
]

// Validation
const rules = computed(() => ({
  editedPhishingReport: {
    email: { required, email }
  }
}));

const v$ = useVuelidate(rules, { editedPhishingReport });

const audience = computed(() => {
  if (!campaigns.value || campaigns.value.length === 0) {
    return "Not Set";
  }

  const firstCampaign = campaigns.value[0];

  if (firstCampaign.user_type === 0) return "Not Set";

  if (firstCampaign.user_type === 1) {
    return firstCampaign.user_count === 0
      ? "Not Set"
      : +firstCampaign.user_count;
  }

  return "Not Set";
});

//v-onboarding
const wrapper = ref(null)
const onboarding = ref(null)
const isTourActive = ref(false)

function onTourStart() {
  isTourActive.value = true
  onboarding.value = useVOnboarding(wrapper)
  onboarding.value.start()
}

function onTourFinish() {
  isTourActive.value = false
}

function onTourExit() {
  isTourActive.value = false
}

const steps = [
  {
    attachTo: { element: '#setup-phishing-tests' },
    content: {
      title: 'Step 1',
      description: "Configure your organisation's set up for automated phishing tests."
    }
  },
  {
    attachTo: { element: '#set-frequency' },
    options: {
      popper: {
        placement: 'top',
        modifiers: [
        {
            name: 'offset',
            options: {
              offset: [0, 70],
            },
          }
        ]
      }
    },
    on: {
      beforeStep: async () => {
        frequencyDialog.value = true
        await nextTick()
        await new Promise(resolve => setTimeout(resolve, 20))
      },
      afterStep: async () => {
        frequencyDialog.value = false
        await nextTick()
        // await new Promise(resolve => setTimeout(resolve, 20))
      }
    },
    content: {
      title: 'Step 2',
      description: 'Select how often you would like phishing tests to be sent to users in your organisation.'
    }
  },
  {
    attachTo: { element: '#confirm-allow-list' },
    options: {
      popper: {
        placement: 'right',
        modifiers: [
        {
            name: 'offset',
            options: {
              offset: [0, 40],
            },
          }
        ]
      }
    },
    on: {
      beforeStep: async () => {
        whitelistDialog.value = true
        await nextTick()
        await new Promise(resolve => setTimeout(resolve, 20))
      },
      afterStep: async (step) => {
        whitelistDialog.value = false
        await nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        if (step.direction == 1) {
          if (!campaigns.value.length) return
          const campaign = campaigns.value[0]
          if (campaign.is_active) return

          // await new Promise(resolve => setTimeout(() => {
          //   setPhishing(true)
          //   resolve()
          // }, 600))

        }
      }
    },
    content: {
      title: 'Step 3',
      description: 'Click here to view details of domains and IPs required to be allow listed. Once allow listing has been completed, please click Confirm.'
    }
  },
  {
    attachTo: { element: '#auto-phishing-toggle' },
    options: {
      popper: {
        placement: 'bottom',
        modifiers: [
        {
            name: 'offset',
            options: {
              offset: [0, 20],
            },
          }
        ]
      }
    },
    content: {
      title: 'Step 4',
      description: 'Once all set up steps have been completed, automated phishing tests can be enabled.'
    }
  },
  {
    attachTo: { element: '#report-notifications-toggle' },
    options: {
      popper: {
        placement: 'bottom-start',
        modifiers: [
        {
            name: 'offset',
            options: {
              offset: [0, 10],
            },
          }
        ]
      }
    },
    content: {
      title: 'Step 5',
      description: 'Phishing report notifications can be enabled here.'
    }
  },
  {
    attachTo: { element: '#manage-recipients' },
    on: {
      beforeStep: async () => {
        phishingReportDialog.value = true
        await nextTick()
        await new Promise(resolve => setTimeout(resolve, 100))
      },
      afterStep: async () => {
        phishingReportDialog.value = false
        await nextTick()
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    },
    content: {
      title: 'Step 6',
      description: 'Manage recipients for phishing test reports by adding and removing users here.'
    }
  },
  {
    attachTo: { element: '#activate-template-toggle' },
    options: {
      popper: {
        placement: 'bottom',
        modifiers: [
        {
            name: 'offset',
            options: {
              offset: [0, 20],
            },
          }
        ]
      }
    },
    content: {
      title: 'Step 7',
      description: 'If a specific phishing template is not relevant to your organisation, it can be disabled here.'
    }
  }
]

const onboardingOptions = {
  popper: {
    placement: 'right',
    modifiers: [
    {
        name: 'offset',
        options: {
          offset: [0, 20],
        },
      },
      {
        name: 'zIndex',
        enabled: true,
        phase: 'beforeWrite',
        fn({ state }) {
          state.styles.popper.zIndex = '9999'
        }
      }
    ]
  },
  overlay: {
    enabled: true,
    padding: { top: 2, right: 2, bottom: 2, left: 2 },
    borderRadius: { top: 5, right: 5, bottom: 5, left: 10 },
    preventOverlayInteraction: false
  },
  scrollToStep: {
    enabled: true,
    options: {
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    }
  },
  autoFinishByExit: true,
  hideButtons: {
    previous: false,
    next: false,
    exit: false
  },
  labels: {
    previousButton: 'Previous',
    nextButton: 'Next',
    finishButton: 'Finish'
  },
  hideNextStepDuringHook: false
}

async function init() {
  loading.value = true
  await getData()
  await getAutoCampaign()
  await checkEnabledFeatures()

  if (templates.value.length === 0) {
    await assignOrgTemplates()
  }

  if (campaigns.value.length === 0) {
    await createCampaign()
  }

  if (!phishingStatus.value) {
    onTourStart()
  }

  loading.value = false
}

function recipientsCheck(){
  if (phishingReports.value.length == 0) {
    phishingReport.value = false
    changePhishingReportStatus()
  }
}

async function checkEnabledFeatures() {
  const orgFeatures = await getOrganisationFeatures();

  if (orgFeatures == null || orgFeatures.length < 1) {
    await createOrganisationFeature();
    addDefaultFeature();
  } else if(orgFeatures[0].phishing_report == null) {
    addDefaultFeature();
  } else {
    //get monthly report recipients
    await getPhishingReportData();


    //check if there is at least one user, if not disable the feature as it requires at least 1 recipient
    if (phishingReports.value.length > 0) {
        phishingReport.value = orgFeatures[0].phishing_report
    } else {
      updateOrganisationFeature(false);
      phishingReport.value = false;
    }
  }
}

async function setTemplate(id, state) {

let data = {
  is_active: !state
};

await axios.put('/orgadmin/organisations/' + orgID.value + '/organisation-phishing/'+id, data)
.then((response) => {
    if (response.data.success){
      toast.success(response.data.message)
    } else {
      toast.error(response.data.message)
    }
})
.catch()

}

async function updateOrganisationFeature(value){
  let data = {
    organisation_id: orgID.value,
    phishing_report: value,
  }
  const orgFeature = await axios.put("/orgadmin/organisations/"+ orgID.value +"/organisation-feature", data)
  return orgFeature
}

async function addDefaultFeature() {
  const report = await addUserRecipient();
  setDefaultFeature();

  if (report) {
    phishingReport.value = true
  }
}

async function addUserRecipient() {
  let data = {
    organisation_id: orgID.value,
    email: store.state.user.organisation.primary_contact_email,
    phishing_report: true,
  }

  const userReport = await axios.post("/orgadmin/trainings/organisations/"+ orgID.value +"/user-report", data)
  .then((response) => {
    if (response.data.success){
      getPhishingReportData()
      return true
    }
    else
      return false
  })

  return userReport
}

function setDefaultFeature() {
 phishingReport.value = true;
  let data = {
    organisation_id: orgID.value,
    phishing_report: true,
  }

 axios.put("/orgadmin/organisations/"+ orgID.value +"/organisation-feature", data)
  .then((response) => {
    if (response.data.success) {
      if (phishingReport.value == true) {
        toast.success('Phishing report has been enabled.')
      }else{
        toast.success('Phishing report has been disabled.')
      }
    }
  })
  .catch();
}

async function createOrganisationFeature(){
  let data = {
      organisation_id: orgID,
      phishing_report: true,
  }

  const orgFeature = await axios.post("/orgadmin/organisations/"+ orgID.value +"/organisation-feature", data)
  .then((response) => {
    if (response.data.success)
      return true
    else
      return false
  })

  return orgFeature
}


async function getPhishingReportData(){
  let data = await axios.get("/orgadmin/trainings/organisations/"+ orgID.value +"/user-report?report=phishing")
    .then((response) => {
      if (response.data.success){
        phishingReports.value = response.data.user_reports
      } else {
        toast.error(response.data.message)
      }
    })
    .catch()

  return data
}

async function getOrganisationFeatures() {
  let data = await axios.get(`/orgadmin/organisations/`+ orgID.value +`/organisation-feature`)
    .then((response) => {
        if (response.data.success){
          return response.data.org_features
        } else {
          toast.error(response.data.message)
          return null
        }
    })
    .catch()

  return data
}

async function getData() {
  tableLoading.value = true
  const params = {
    filter: search.value,
    sort: sortBy.value ? sortBy.value.value : ''
  }

  try {
    const response = await axios.get(`/orgadmin/organisations/${orgID.value}/organisation-phishing`, { params })
    if (response.data.success) {
      templates.value = response.data.templates
    } else {
      toast.error(response.data.message)
    }
  } catch (error) {
    console.error('Error:', error)
    toast.error('An error occurred while fetching data.')
  }

  tableLoading.value = false
}

async function assignOrgTemplates() {
  await axios.post(`/orgadmin/organisations/${orgID.value}/organisation-phishing/assign`)
  await getData()
  await createCampaign()
  await getAutoCampaign()
}

async function getAutoCampaign() {
  try {
    const response = await axios.get(`/orgadmin/organisations/${orgID.value}/organisation-campaign`)
    if (response.data.success) {
      campaigns.value = response.data.campaigns
      if (campaigns.value.length !== 0) {
        phishingStatus.value = campaigns.value[0].is_active
        status.value = campaigns.value[0].is_active
        frequencySet.value = campaigns.value[0].frequency > 0
        whiteListSet.value = campaigns.value[0].whitelisted
      }
    } else {
      toast.error(response.data.message)
    }
  } catch (e) {
    console.Error(e)
  }
}

async function createCampaign() {
  await axios.post(`/orgadmin/organisations/${orgID.value}/organisation-campaign`)
  await getAutoCampaign()
  phishingStatus.value = campaigns.value[0]?.is_active
}

function closeFrequencyDialog() {

  if (isTourActive.value == true)
    onboarding.value.finish()

  frequencyDialog.value = false
}

function closeReportDialog(){
  if (isTourActive.value == true) {
    onboarding.value.finish()
  }

  phishingReportDialog.value = false;
  editedPhishingReport.email = null;
  v$.value.$reset()
  editedIndex.value = -1;
}

function saveRecipient() {
  let toContinue = true
  phishingReports.value.forEach(v => {
    if (v.email == editedPhishingReport.email) {
      toContinue = false
      toast.error("Recipient already exists.")
    }
  });

  if (!toContinue) return

  v$.value.editedPhishingReport.email.$touch();
  if (v$.value.editedPhishingReport.email.$invalid) return

  let data = {
      email: editedPhishingReport.email,
      phishing_report: true,
  }

  if (editedIndex.value > -1) {
      axios.put("/orgadmin/trainings/organisations/"+ orgID.value +"/user-report/"+ phishingReportID.value, data)
      .then((response) => {
          if (response.data.success){
              toast.success(response.data.message)
              getPhishingReportData();
              editedIndex.value = -1;
              editedPhishingReport.email = null
          } else {
              toast.error(response.data.message)
          }
      })
      .catch()
  } else {
      axios.post("/orgadmin/trainings/organisations/"+ orgID.value +"/user-report", data)
      .then((response) => {
          if (response.data.success){
            editedPhishingReport.email = null
            if (phishingReports.value.length < 1) {
                addRecipientRequired.value = true;
            }

            //turn on monthly report if add at least 1 recipient is set to true
            if (addRecipientRequired.value == true) {
              phishingReportDialog.value = true;
              changePhishingReportStatus();
            }

            toast.success(response.data.message)
            getPhishingReportData();
          } else {
              toast.error(response.data.message)
          }
      })
      .catch()
  }
  v$.value.$reset()
}

function deleteRecipient(item) {
  editedIndex.value = phishingReports.value.indexOf(item);

  if (confirm("Do you really want to delete this email?")) {
    axios
      .delete("/orgadmin/trainings/organisations/" + orgID.value + "/user-report/" + item.ID)
      .then((response) => {
        if (response.data.success) {
          phishingReports.value.splice(editedIndex.value, 1);
          toast.success(response.data.message);
          editedIndex.value = -1;
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(() => {
        toast.error("An error occurred while deleting the email.");
      });
  }
}

function changePhishingReportStatus(notify) {
  let data = {
      organisation_id: orgID.value,
      phishing_report: !phishingReport.value,
  }

  if (addRecipientRequired.value == false) {
      if (phishingReport.value && phishingReports.value.length < 1) {
          phishingReportDialog.value = true;
          addRecipientRequired.value = true;
          toast.warning('Please add at least one recipient.')
          return
      }
  }

  axios.put("/orgadmin/organisations/"+ orgID.value +"/organisation-feature", data)
  .then((response) => {
      if (response.data.success) {
        //only show notif when changing status using the toggle button
        if (addRecipientRequired.value == false) {
          if (!notify) return

          if (phishingReport.value == true)
            toast.success('Phishing report has been enabled.')
          else
            toast.success('Phishing report has been disabled.')
        }

        if (addRecipientRequired.value == true) {
          addRecipientRequired.value = false;
        }
      }
  })
  .catch();
}

async function setFrequency(value) {
  const data = {
    frequency: parseInt(value),
    organisation_id: orgID.value
  }

  const campaignID = campaigns.value[0]?.ID
  try {
    const response = await axios.put(`/orgadmin/organisations/${orgID.value}/organisation-campaign/${campaignID}`, data)
    if (response.data.success) {
      await getAutoCampaign()

      if (frequencySet.value == true) {
        toast.success("Successfully updated Frequency.")
      }
    } else {
      toast.error(response.data.message)
    }
  } catch (e) {
    console.Error(e)
  }

  frequencyDialog.value = false
}

function closeWhitelistDialog() {
  whitelistDialog.value = false
}

async function setWhitelist(value) {
  settingWhiteList.value = true

  const data = {
    whitelisted: value,
    organisation_id: orgID.value
  }

  const campaignID = campaigns.value[0]?.ID
  try {
    const response = await axios.put(`/orgadmin/organisations/${orgID.value}/organisation-campaign/${campaignID}`, data)
    if (response.data.success) {
      await getAutoCampaign()

      if (whiteListSet.value == true) {
        toast.success("Successfully setup Allow listing.")
      }
    } else {
      toast.error("Failed to set whitelisting.")
    }

    settingWhiteList.value = false
  } catch (e) {
    console.Error(e)
    settingWhiteList.value = false
  }

  whitelistDialog.value = false
}

//watcher for whitelist status
  // Watch for changes to sortBy
  watch(settingWhiteList, (status) => {

    if (!isTourActive.value) return

    if (campaigns.value.length > 0 && campaigns.value[0].is_active) return

    if (status == false) {
      phishingStatus.value = true
      setPhishing(true)
    }
  });

// async function setAudience() {
//   audienceLoading.value = true
//   await setCampaignUserType(1)
//   await getAutoCampaign()
//   audienceLoading.value = false
// }

// async function setCampaignUserType(type) {
//   const data = {
//     user_type: type,
//     organisation_id: orgID.value
//   }

//   const campaignID = campaigns.value[0]?.ID
//   try {
//     const response = await axios.put(`/orgadmin/organisations/${orgID.value}/organisation-campaign/${campaignID}`, data)
//     if (!response.data.success) {
//       toast.error("Failed to add users to campaign.")
//     }
//   } catch (e) {
//     console.error(e)
//   }
// }

function setPhishing(fromTour) {
  if (campaigns.value.length === 0) {
    phishingStatus.value = false
    nextTick(() => phishingStatus.value = false)
    return
  }

  if (!frequencySet.value) {
    if (!fromTour) toast.error("Need to setup Frequency.")
    phishingStatus.value = false
    nextTick(() => phishingStatus.value = false)
    return
  }

  if (!whiteListSet.value) {
    if (!fromTour) toast.error("Need to setup Allow list.")
    phishingStatus.value = false
    nextTick(() => phishingStatus.value = false)
    return
  }

  activatePhishing()
}

async function activatePhishing() {
  const today = moment()
  const campaign = campaigns.value[0]
  const activeStatus = phishingStatus.value


  const data = {
    is_active: activeStatus,
    organisation_id: orgID.value,
    start_date: today.format(),
    end_date: today.add(campaign.frequency, 'days').format()
  }

  try {
    const response = await axios.put(`/orgadmin/organisations/${orgID.value}/organisation-campaign/${campaign.ID}`, data)
    if (response.data.success) {
      const msg = activeStatus ? "Phishing Campaign has been enabled." : "Phishing Campaign has been disabled."
      toast.success(msg)
      await getAutoCampaign()
    } else {
      toast.error("Failed to set phishing on.")
    }
  } catch (e) {
    console.Error(e)
  }
}

function editPhishingReport(item) {
  editedIndex.value = phishingReports.value.indexOf(item)
  editedPhishingReport.email = item.email
  phishingReportID.value = item.ID
}

onMounted(() => {
  init();
});

// Debounced search watcher
watch(search, debounce(() => {
    templates.value = [];
    getData();  // Call getData when search changes
  }, 600));

  // Watch for changes to sortBy
  watch(sortBy, () => {
    getData();
  });

  // Watch for changes to organisation
  watch(() => store.state.user.organisation, (newOrg) => {
    if (store.state.auth.accessToken == null) return;
    orgID.value = newOrg.id;
    init();
  });
</script>


<style scoped>
.form-control{
  -webkit-border-radius: 0px;
     -moz-border-radius: 10px;
          border-radius: 10px;
}
.btn-create {
  -webkit-border-radius: 20px;
     -moz-border-radius: 20px;
          border-radius: 20px;
  font-size:13px;
  font-weight: 900;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 0px;
}

.btn-square {
  -webkit-border-radius: 0px;
     -moz-border-radius: 0px;
          border-radius: 0px;
  border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
   font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
      font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
      font-size: 14px!important;
}

.video {
  width:100%;
}

/* buttons override */
.btn-circle-danger {
	width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

 .btn-circle-danger:hover {
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

.btn-circle-danger:focus{
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

.text-default{
	color: #435666;
}

div.inline { float:left;}

.form-check-input:checked {
  background-color: #00a0c1;
  border-color: #00d3fd;
}

td {
  white-space: normal !important;
  word-wrap: break-word;
}

.form-control::placeholder {
    color: #555555;
  }
</style>

<!-- custom icons -->
<style scoped>
/* Common styles for icons */
.custom-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0; /* Remove padding to avoid extra spacing */
  border-radius: 50%; /* Make the button round */
}

.custom-icon-btn svg {
  width: 20px;
  height: 20px;
}

/* Adjust the size of the edit icon */
.custom-icon-btn i.fa-pen {
  font-size: 14px;
}

/* The container holding all buttons */
.inline-block {
  display: flex;
  align-items: center; /* Vertically center the items */
  flex-wrap: wrap; /* Allow icons to wrap to the next line */
  gap: 5px; /* Add some spacing between the stacked icons */
}

/* Custom slider styles */
.custom-slider {
  position: relative;
  width: 42px;
  height: 22px;
  margin-right: 5px; /* Add some space between the slider and other icons */
}

.custom-slider .slider {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 40px; /* Adjust the width of the slider background */
  height: 20px; /* Adjust the height of the slider background */
  background-color: #B5DAC6;
  border-radius: 11px;
  cursor: pointer;
  transition: 0.4s;
}

.custom-slider .slider-button {
  position: absolute;
  top: 0px;
  left: 1px;
  width: 20px; /* Adjust the width of the slider button */
  height: 20px; /* Adjust the height of the slider button */
  background-color: #00B972; /* Slightly different shade of green */
  border-radius: 50%;
  transition: 0.4s;
}

/* Move the slider button when it's checked (toggled on) */
.form-check-input:checked + .slider .slider-button {
  transform: translateX(20px);
  background-color: #00B972; /* Green color for the checked/active state */
}

/* Adjust the background color when the slider is toggled off (unchecked) */
.form-check-input:not(:checked) + .slider .slider-button {
  background-color: grey; /* Grey color for the unchecked/inactive state */
  transform: translateX(0); /* Reset transform when unchecked */
}

/* Adjust the background color when the slider is toggled off (unchecked) */
.form-check-input:not(:checked) + .slider  {
  background-color: #bebebe; /* Grey color for the unchecked/inactive state */
  transform: translateX(0); /* Reset transform when unchecked */
}

/* Hide the default checkbox input */
.form-check-input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Media Query for smaller screen sizes */
@media screen and (max-width: 768px) {
  .inline-block {
    flex-wrap: wrap; /* Allow icons to wrap to the next line */
  }

  .custom-icon-btn i.fa-pen {
    font-size: 16px; /* Adjust the size as needed */
  }

  /* Adjust the size of the slider button for smaller screens */
  .custom-slider .slider-button {
    width: 18px;
    height: 18px;
  }

  /* Adjust the size of other icons for smaller screens */
  .custom-icon-btn svg {
    width: 14px;
    height: 14px;
  }
}

.form-check-input:checked {
    background-color: #00A0C1;
    border-color: #00A0C1;
  }

.default {
  border-color: #00A0C1;
  color: #00A0C1;
  margin:3px;
}

.default:hover {
  background: #00A0C1;
  color:white;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}

.btn-labeled:active {
  color: white;
}
.text-small{
  font-size: 10px;
}
</style>